export const NEW_HOME_BLOG_POST = 31;
export const NEW_SENIOR_DOCUMENT = 21;
export const NEW_HOME_DOCUMENT = 11;
export const NEW_MESSAGE_FROM_SENIOR = 24;
export const NEW_MESSAGE_FROM_HOME = 0;
